import React from "react";
import { HiOutlineUserGroup } from "react-icons/hi2";
import { GrAnnounce } from "react-icons/gr";

const ChatListHeader = ({
  setCreateNewGroupSection,
  setCreateNewChannelSection,
  type,
  setMoreNewChat,
}) => (
  <div className="w-full gap-4 pt-2">
    {type === "group" ? (
      <button
        onClick={() => {
          setCreateNewGroupSection(1);
          setMoreNewChat(false);
        }}
        className="btn btn-primary pl-2 h-12 bg-transparent text-[#7C7C7C] hover:text-[var(--primary-color)] border font-normal border-[#EBEBEB] w-full shadow-none rounded-lg mb-3 flex justify-start items-center gap-2"
      >
        <HiOutlineUserGroup className="rounded-full bg-[var(--primary-color)] text-white p-1.5 text-3xl" />
        New Group
      </button>
    ) : (
      <button
        onClick={() => {
          setCreateNewChannelSection(1);
          setMoreNewChat(false);
        }}
        className="btn btn-primary pl-2 h-12 bg-transparent hover:text-[var(--primary-color)] text-[#7C7C7C] border font-normal border-[#EBEBEB] w-full shadow-none rounded-lg  flex justify-start items-center gap-2"
      >
        <GrAnnounce className="rounded-full bg-[var(--primary-color)] text-white p-1.5 text-3xl" />
        New Channel
      </button>
    )}
  </div>
);

export default ChatListHeader;
